import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const UpgradeCard = ({ title, chips, prompt, description, imageSrc }) => {
  return (
    <div className="mystical-card group transition-all duration-300 hover:shadow-purple-700/10">
      <div className="p-4">
        {/* Actual upgrade image */}
        {imageSrc && (
          <div className="mb-4 flex justify-center">
            <img 
              src={imageSrc} 
              alt={title} 
              className="w-48 h-48 object-cover rounded-lg"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="w-48 h-48 bg-gradient-to-br from-purple-300 to-pink-200 rounded-lg flex items-center justify-center" style={{display: 'none'}}>
              <span className="text-4xl">✨</span>
            </div>
          </div>
        )}
        
        <h4 className="mystical-subtitle text-black text-xl mb-3">{title}</h4>
        
        {prompt && (
          <div className="mystical-card bg-purple-700 bg-opacity-10 mb-3">
            <p className="mystical-text text-gray-800 text-sm italic leading-relaxed">
              [ {prompt} ]
            </p>
          </div>
        )}
        
        {description && (
          <p className="mystical-text text-gray-800 mb-4 text-sm leading-relaxed">
            {description}
          </p>
        )}
        
        {chips && (
          <div className="mystical-card bg-purple-700 bg-opacity-20">
            <p className="mystical-text text-purple-800 font-bold">
              CHIPS: {chips}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const SectionHeader = ({ title }) => {
  return (
    <div className="mystical-card bg-purple-800 bg-opacity-20 mb-6">
      <h3 className="mystical-subtitle text-black text-2xl text-center">{title}</h3>
    </div>
  );
};

const MystveilUpgradesPage = () => {
  const [timeLeft, setTimeLeft] = useState({});
  const [showHalloween, setShowHalloween] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const halloween = new Date(currentYear, 9, 31, 23, 59, 59); // October 31st at 11:59:59 PM
      
      // If Halloween has passed this year, check next year
      if (now > halloween) {
        halloween.setFullYear(currentYear + 1);
      }

      const difference = halloween - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        return { days, hours, minutes, seconds };
      } else {
        setShowHalloween(false);
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Initial calculation
    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, []);

  // Upgrades data organized by category and chip cost
  const upgrades = {
    // HEAD UPGRADES (organized by chip cost: low to high)
    head: [
      {
        title: "Hair fluff",
        chips: 3,
        description: "A little tuft of hair on the top of your head! Must not reach beyond a Hatchling's eyes and must be the color where the hair sprouts from. Can be any texture or style.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Hair%20tuft.png"
      },
      {
        title: "Teefs",
        chips: 5,
        description: "Some big ol chompers! Can be any natural arrangement of teeth. Must be rooted inside the mouth and be white or off white.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Teefs.png"
      },
      {
        title: "Eyebrow shape changer",
        chips: 5,
        prompt: "Draw your Hatchling being confused by something",
        description: "Changes the shape of your eyebrows from bean brows to any shape that suits your need! Eyebrow's color must remain the same or black, must fit proportionally on the face.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Eyebrows.png"
      },
      {
        title: "Cheek fluff",
        chips: 7,
        description: "Tufts of fur coming off from your cheeks. Must be the color where the fur grows from, fur must remain short.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Cheek%20tuft.png"
      },
      {
        title: "Slit Pupils",
        chips: 10,
        prompt: "Draw your hatchling exploring at night!",
        description: "Turns your pupils sharp like a cat's!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/slit%20eyes.png"
      },
      {
        title: "Snout Scales",
        chips: 10,
        prompt: "add a few plated scales to the briddge of your snout! Should line up at about the middle of the face",
        description: "some hefty plated scales to armor your face! should be thee same color as the bridge of your veilkins snout",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/Nosescales.png"
      },
      {
        title: "Beans!",
        chips: 20,
        prompt: "Paw pads and toe beans on the underside of your hatchlings paws",
        description: "get yourself some squishy toe beans!! they can be one color from your hatchlings existing pallete",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/beans.png"
      },
      {
        title: "Fangs/Tusks",
        chips: 40,
        prompt: "Teefs, but bigger! should be 2 teeth sticking up or down from outside the mouth",
        description: "the better to snack with, my dear! should follow your existing tooth color",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/fangs_tusks_gif.gif"
      },
      {
        title: "Colored Nose",
        chips: 45,
        prompt: "Change the color of your sniffer! can be black, or any of your existing pallete",
        description: "pretty straight forward!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Colored_nose.png"
      },
      {
        title: "Colored Sclera",
        chips: 80,
        prompt: "Change the color of your hatchling scelera",
        description: "Can be any pastel color!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/colored_sclera.png"
      },
      {
        title: "Pupil Color Changer",
        chips: 90,
        prompt: "Change the color of your hatchling pupils",
        description: "Can change to either solid white or black",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/ezgif-58749bd037d36c.gif"
      },
      
    ],
    // EAR UPGRADES (organized by chip cost: low to high)
    ears: [
      {
        title: "Ear tufts",
        chips: 25,
        prompt: "Draw your Hatchling making something like cooking or crafting",
        description: "Adds fluff to your current set of ears.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/fluffy%20ears.png"
      },
      {
        title: "\"Billy\" ears",
        chips: 30,
        description: "Changes the shape of your Hatchling's ears to be hanging and longer.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Billie%20ears.png"
      },
      {
        title: "Round ears",
        chips: 35,
        description: "Makes your ears round like a big cat or a bear, but larger.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Round%20ears.png"
      },
      {
        title: "Sharp ears",
        chips: 35,
        description: "Changes the shape of your hatchlings ears to be tall and spikey.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Sharp%20ears.png"
      },
      {
        title: "Notched Ears",
        chips: 40,
        prompt: "Long thin ears with cool notches in the sides",
        description: "Should follow your existing ear color and markings",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Notched_ears.png"
      },
      {
        title: "Bat Ears",
        chips: 45,
        prompt: "big triagular ears with a ribbed inner ear",
        description: "Perfect for eavesdropping",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Bat_ears.png"
      },
      {
        title: "Buzzy Ears",
        chips: 45,
        prompt: "Ears that slightly resemble bug wings!",
        description: "should still follow your ear colors and markings",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Buzzy_ears.png"
      }
    ],
    // BODY UPGRADES (organized by chip cost: low to high)
    body: [
      {
        title: "Body fluff",
        chips: 10,
        description: "Gives your hatchling longer fur. Doesn't change the color of your fur, must be mid length or shorter, nothing too shaggy or long, but can be in any style",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Body%20fluff.png"
      },
      {
        title: "Back spikes",
        chips: 10,
        description: "Gives your 3 curved spikes on their back. Can be one of the colors already on your Hatchling.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Back%20spikes.png"
      },
      {
        title: "Rump fluff",
        chips: 12,
        description: "Gives your hatchling longer fur on the upper back of their legs.",
        prompt: "Draw your hatchling running to/from something!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Rump%20fluff.png"
      },
      {
        title: "Back Scales",
        chips: 15,
        description: "4 armored scales on your hatchlings back. Can be one of the colors already on your Hatchling.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Back%20plates.png"
      },
      {
        title: "Armwings",
        chips: 70,
        prompt: "Wings that attach to your Veilkins arm, and go from their wrist to their torso! Can be feathered or webbed!",
        description: "While you may not be able to fly with these bad boys, they are pretty stylish! can be one of the colors already on your hatchling",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/UGgifs/arm_wings_upgrade.gif"
      },
      {
        title: "Little feathered wings",
        chips: 80,
        description: "Little flightless bat-like wings. Can be one of the colors already on your Hatchling.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Feathered%20wings.png"
      },
      {
        title: "Little bat wings",
        chips: 90,
        description: "Little flightless bat-like wings. Can be one of the colors already on your Hatchling.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Bat%20wings.png"
      }
    ],
    // LEG UPGRADES (organized by chip cost: low to high)
    legs: [
      {
        title: "Arm fluff",
        chips: 10,
        description: "Tufts of mid length fur on your hatchlings arms.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Arm_fluff.png"
      },
      {
        title: "Leg Scales",
        chips: 13,
        description: "Armored scale plates on the front of your arms. Can be one of the colors already on your Hatchling.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Arm%20plates.png"
      },
      {
        title: "Claws",
        chips: 15,
        prompt: "Draw your Hatchling digging for something",
        description: "Claws that come out of your front and/or back paws! Can be white, black, or your accent color.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Claws.png"
      }
    ],
    // TAIL UPGRADES (organized by chip cost: low to high)
    tail: [
      {
        title: "Nub tail",
        chips: 25,
        description: "Small rabbit-like tail.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Nub%20tail.png"
      },
      {
        title: "Fluffy tail",
        chips: 30,
        description: "Gives your tail more fur! Mid length fur, not too long",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Fluffy%20tail.png"
      },
      {
        title: "No Tail",
        chips: 50,
        description: "Pretty self explanatory, you have no more tail!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/No%20tail.png"
      },
      {
        title: "Longer tail",
        chips: 70,
        prompt: "Draw your hatchling reaching for something that's far away from them",
        description: "Makes your tail longer than it was! Maximum length is your Hatchling's torso.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Long%20tail.png"
      }
    ],
    // MARKING UPGRADES (organized by chip cost: low to high)
    markings: [
      {
        title: "Calico Markings",
        chips: 45,
        prompt: "a dark and light color splotch pattern",
        description: "can be any of your existing colors, and overlap existing markings",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Calico_Marking.png"
      },
      {
        title: "Pinstripe Markings",
        chips: 45,
        prompt: "a section of your markings outlined by a pinstripe of a different color",
        description: "can be any of your existing colors, and overlap existing markings",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/pinstripe_Marking.png"
      },
      {
        title: "Freckles",
        chips: 50,
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/freckles.png"
      },
      {
        title: "Spots",
        chips: 65,
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Markings%20-%20Spots.png"
      },
      {
        title: "Stripes",
        chips: 65,
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Markings%20-%20Stripes.png"
      },
      {
        title: "Splotches",
        chips: 70,
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/images/Markings%20-%20Splotches.png"
      }
    ],
    // MISC UPGRADES (free options)
    misc: [
      {
        title: "Accessories and Clothing",
        description: "Free! Feel free your Hatchling however you'd like with any non-modern style clothing and accessories."
      },
      {
        title: "Trait remover",
        description: "Free! Not liking a trait or upgrade you put on your Hatchling? Don't worry! Feel free to remove them at any time."
      }
    ],
    // TIMBERTERROR SPECIALS (seasonal exclusive upgrades)
    halloween: [
      {
        title: "Octotail",
        chips: "Limited Time",
        description: "A mysterious octopus-like tail with tentacle details perfect for Halloween!",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Octotail.png"
      },
      {
        title: "Peeper Wings",
        chips: "Limited Time",
        description: "Spooky wings with multiple eyes that seem to watch everything around them.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Peeper_wings.png"
      },
      {
        title: "Wereclaws",
        chips: "Limited Time",
        description: "Fierce werewolf-style claws that extend from your hatchling's paws.",
        imageSrc: "https://cdn.4fingerstudios.com/Mystveil/Halloween25/Wereclaws.png"
      }
    ]
  };

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto">
          {/* Guide Section */}
          <div className="mystical-card mb-12">
            <h1 className="mystical-title text-black mb-8">
              Mystveil Upgrades Guide
            </h1>

            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                General Synopsis
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  Every upgrade will usually have a Chip requirement amount, and sometimes a prompt to go with it! In order to claim an upgrade, you must fulfill all of the requirements listed on said upgrade first! Once those requirements are filled, you can apply the upgrade in your next image.
                </p>
                <p className="mystical-text text-black">
                  Upgrades are usually the same color as wherever they grow from, unless specified otherwise!
                </p>
                <p className="mystical-text text-black">
                  When you apply an upgrade, they must be applied in at least a colored piece. Sketches don't count for applying upgrades!
                </p>
              </div>
            </div>

            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                Upgrade Description Rundown
              </h2>
              <p className="mystical-text text-black mb-6">
                When you look to apply an upgrade, make sure to look at these requirements!
              </p>
              <div className="mystical-card bg-purple-700 bg-opacity-10">
                <ul className="space-y-2">
                  <li className="mystical-text text-gray-800">
                    <span className="font-bold text-purple-800">Chips #:</span> Specifies the amount of Chips you'll need total in order to get this upgrade
                  </li>
                  <li className="mystical-text text-gray-800">
                    <span className="font-bold text-purple-800">Age:</span> Specifies how old your hatchling must be (In real time) in order for them to qualify for this upgrade
                  </li>
                  <li className="mystical-text text-gray-800">
                    <span className="font-bold text-purple-800">Prompt:</span> Upgrades sometimes come with an art prompt! You'll need to draw/create and submit this prompt to the group in order to qualify for this upgrade
                  </li>
                  <li className="mystical-text text-gray-800">
                    <span className="font-bold text-purple-800">Needs:</span> Sometimes upgrades will require you to have an already existing upgrade before you can get this new upgrade! For example, needing small feathered flightless wings in order to eventually get bigger wings that can fly!
                  </li>
                </ul>
              </div>
            </div>

            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                Important Notes
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  Remember that hatchlings can only have hatchling upgrades! As of right now you cannot apply adult upgrades onto a hatchling.
                </p>
                <p className="mystical-text text-black">
                  Something important to note about upgrades is that you cannot have 2 separate upgrades occupying the same space that cannot exist there. For example, you cannot have both Sharp ears and Billie ears, because you can't have 4 sets of ears, so you'd have to pick one or the other. But, you could have sharp ears and fluffy ears, as fluffy ears just makes your current ears fluffy!
                </p>
              </div>
            </div>

            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                Stylization
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  The general rule of stylization with upgrades is so long as we're able to recognize the upgrade at first glance, you're good to go! There are some upgrades that allow lots of stylization options, for example hair upgrades! Just make sure they're still within the set boundaries.
                </p>
                <p className="mystical-text text-black">
                  It's possible that if you go too far off from the original upgrade, or make your upgrade look like an upgrade you don't own, staff may ask you to change it.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <Link to="/guide" className="mystical-button">
                Back to Guides
              </Link>
            </div>
          </div>

          {/* Upgrades Catalog */}
          <div className="mystical-card">
            <div className="text-center mb-8">
              <h2 className="mystical-title text-black mb-4">Get Your Upgrades Here!</h2>
              <p className="mystical-text text-lg">Collect Chips And Upgrade Your Characters!</p>
              <p className="mystical-text text-sm mt-2">artwork created by Opossol</p>
            </div>

            {/* Head Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Head" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.head.map((upgrade, index) => (
                  <UpgradeCard key={`head-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Ears Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Ears" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.ears.map((upgrade, index) => (
                  <UpgradeCard key={`ears-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Body Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Body" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.body.map((upgrade, index) => (
                  <UpgradeCard key={`body-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Legs Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Legs" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.legs.map((upgrade, index) => (
                  <UpgradeCard key={`legs-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Tail Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Tail" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.tail.map((upgrade, index) => (
                  <UpgradeCard key={`tail-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Markings Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Markings" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.markings.map((upgrade, index) => (
                  <UpgradeCard key={`markings-${index}`} {...upgrade} />
                ))}
              </div>
            </div>

            {/* Halloween Upgrades */}
            {showHalloween && (
              <div className="mb-12 relative">
                {/* Dark Pumpkin Background Effects */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-900/20 via-black/40 to-amber-900/20 rounded-2xl"></div>
                <div className="absolute top-4 left-4 text-2xl opacity-15 text-orange-600">🎃</div>
                <div className="absolute top-4 right-4 text-2xl opacity-15 text-orange-600">🎃</div>
                <div className="absolute bottom-4 left-4 text-2xl opacity-15 text-orange-600">🎃</div>
                <div className="absolute bottom-4 right-4 text-2xl opacity-15 text-orange-600">🎃</div>
                
                {/* Dark Pumpkin Section Header with Countdown */}
                <div className="relative z-10 mb-8">
                  <div className="mystical-card bg-gradient-to-r from-orange-900 via-black to-amber-900 bg-opacity-70 border-2 border-orange-600 shadow-lg shadow-orange-500/20">
                    <h3 className="mystical-subtitle text-orange-100 text-3xl text-center font-bold tracking-wider drop-shadow-lg">
                      🌲 TIMBERTERROR 🌲
                    </h3>
                    
                    {/* Countdown Timer */}
                    <div className="mt-6 grid grid-cols-4 gap-4 max-w-md mx-auto">
                      <div className="text-center">
                        <div className="bg-orange-800/50 rounded-lg p-3 border border-orange-600">
                          <div className="text-orange-100 text-2xl font-bold">{timeLeft.days || 0}</div>
                          <div className="text-orange-200 text-sm">Days</div>
                        </div>
                      </div>
                      <div className="text-center">
                        <div className="bg-orange-800/50 rounded-lg p-3 border border-orange-600">
                          <div className="text-orange-100 text-2xl font-bold">{timeLeft.hours || 0}</div>
                          <div className="text-orange-200 text-sm">Hours</div>
                        </div>
                      </div>
                      <div className="text-center">
                        <div className="bg-orange-800/50 rounded-lg p-3 border border-orange-600">
                          <div className="text-orange-100 text-2xl font-bold">{timeLeft.minutes || 0}</div>
                          <div className="text-orange-200 text-sm">Minutes</div>
                        </div>
                      </div>
                      <div className="text-center">
                        <div className="bg-orange-800/50 rounded-lg p-3 border border-orange-600">
                          <div className="text-orange-100 text-2xl font-bold">{timeLeft.seconds || 0}</div>
                          <div className="text-orange-200 text-sm">Seconds</div>
                        </div>
                      </div>
                    </div>
                    <p className="text-center text-orange-300 text-sm mt-4">
                      Until Halloween Ends!
                    </p>
                  </div>
                </div>
                
                {/* Dark Pumpkin Cards Grid */}
                <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {upgrades.halloween.map((upgrade, index) => (
                    <div key={`halloween-${index}`} className="relative group">
                    {/* Dark Pumpkin Card Glow Effect */}
                    <div className="absolute inset-0 bg-gradient-to-br from-orange-600/10 via-amber-600/10 to-black/15 rounded-xl blur-sm group-hover:blur-sm transition-all duration-300"></div>
                      
                      {/* Main Dark Pumpkin Card */}
                      <div className="relative group transition-all duration-300 border-2 border-orange-600 shadow-lg shadow-orange-500/20 hover:shadow-orange-400/30 backdrop-filter-blur rounded-2xl p-6" style={{background: 'linear-gradient(135deg, rgba(154, 52, 18, 0.4) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(180, 83, 9, 0.4) 100%)'}}>
                          {/* Dark Pumpkin Image with Special Effects */}
                          {upgrade.imageSrc && (
                            <div className="mb-4 flex justify-center relative">
                              <div className="absolute inset-0 bg-gradient-to-br from-orange-600/30 to-amber-600/30 rounded-lg blur-sm"></div>
                              <img 
                                src={upgrade.imageSrc} 
                                alt={upgrade.title} 
                                className="relative w-48 h-48 object-cover rounded-lg border-2 border-orange-500 shadow-lg filter brightness-90 sepia-10"
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              <div className="w-48 h-48 bg-gradient-to-br from-orange-700 via-orange-800 to-amber-800 rounded-lg flex items-center justify-center border-2 border-orange-500" style={{display: 'none'}}>
                                <span className="text-4xl text-orange-300">🎃</span>
                              </div>
                            </div>
                          )}
                          
                          <h4 className="mystical-subtitle text-orange-100 text-xl mb-3 font-bold text-center drop-shadow-md">
                            {upgrade.title}
                          </h4>
                          
                          {upgrade.prompt && (
                            <div className="mystical-card bg-orange-800 bg-opacity-40 border border-orange-600 mb-3">
                              <p className="mystical-text text-orange-200 text-sm italic leading-relaxed">
                                [ {upgrade.prompt} ]
                              </p>
                            </div>
                          )}
                          
                          {upgrade.description && (
                            <p className="mystical-text text-orange-200 mb-4 text-sm leading-relaxed text-center">
                              {upgrade.description}
                            </p>
                          )}
                          
                          {upgrade.chips !== undefined && (
                            <div className="mystical-card bg-gradient-to-r from-orange-700 to-amber-700 bg-opacity-60 border border-orange-500">
                              <p className="mystical-text text-orange-100 font-bold text-center">
                                🎃 CHIPS: {upgrade.chips} 🎃
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
                
                {/* TimberTerror Footer Text */}
                <div className="relative z-10 mt-8 text-center">
                  <p className="text-orange-300 font-semibold text-lg drop-shadow-md">
                    🌲 Embrace the TimberTerror from Mystveil! 🌲
                  </p>
                </div>
              </div>
            )}

            {/* Misc Upgrades */}
            <div className="mb-12">
              <SectionHeader title="Misc" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {upgrades.misc.map((upgrade, index) => (
                  <UpgradeCard key={`misc-${index}`} {...upgrade} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default MystveilUpgradesPage;